import React from 'react';
import Loader from "react-loader-spinner";

const SpinLoader = () => {
    return (
        <div className='spin_center'>
            <Loader
                type="MutatingDots"
                color="#66FCF1"
                secondaryColor='#02062A' 
                height={100}
                width={100}
                timeout={4000}
            />
        </div>
    );
};

export default SpinLoader;